import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import api from "../services/api.service";
import * as Styles from "../styles/ReviewOrderInfo.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";

interface ReviewOrderInfoModalProps {
  isOpen: boolean;
  setSearchValueInput: (value: string) => void;
  onRequestClose: () => void;
}

const ReviewOrderInfoModal: React.FC<ReviewOrderInfoModalProps> = ({
  isOpen,
  setSearchValueInput,
  onRequestClose,
}) => {
  const {
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    authUserZustand,
    setMessageZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
    };
  });
  const modalWrapperRef = useRef<HTMLDivElement>(null);

  //ALTERAR MESA SELECIONADA:
  interface Desk {
    itemUuid: string;
    itemName: string;
    itemOrder: any;
  }
  const [availableDesks, setAvailableDesks] = useState<Desk[]>([]);
  useEffect(() => {
    const fetchAvailableDesks = async () => {
      const tempAvailableDesks = [];
      try {
        const desksResponse = await api.get(`itensAvailable/4`);
        const desks = desksResponse.data;
        if (desks?.length > 0) {
          for (const desk of desks) {
            tempAvailableDesks.push({
              itemUuid: desk.itemUuid,
              itemName: desk.itemName,
              itemOrder: desk.itemOrder,
            });
          }
          setAvailableDesks(tempAvailableDesks);
        }
      } catch (error: any) {
        setMessageZustand(
          `Erro ao buscar mesas disponíveis: ${error.message}`,
          `error`
        );
      }
    };

    fetchAvailableDesks();
  }, []);

  const [selectedDesk, setSelectedDesk] = useState<Desk | null>(null);

  const handleChangeDeskUuid = (event: ChangeEvent<HTMLSelectElement>) => {
    const selectedDesk = availableDesks.find(
      (desk: Desk) => desk.itemName === event.target.value
    );
    setSelectedDesk(selectedDesk || null);
    setSearchValueInput(event.target.value);
  };

  //FIM DO MESA SELECIONADA


  //ALTERAR COUNTER SELECIONADO:
  interface Counter {
    itemUuid: string;
    itemName: string;
    itemOrder: any;
  }
  const [availableCounters, setAvailableCounters] = useState<Counter[]>([]);

  useEffect(() => {
    const fetchAvailableCounters = async () => {
      const tempAvailableCounters = [];
      try {
        const countersResponse = await api.get(`itensAvailable/5`);
        const counters = countersResponse.data;
        if (counters?.length > 0) {
          for (const counter of counters) {
            tempAvailableCounters.push({
              itemUuid: counter.itemUuid,
              itemName: counter.itemName,
              itemOrder: counter.itemOrder,
            });
          }
          setAvailableCounters(tempAvailableCounters);
        }
      } catch (error: any) {
        setMessageZustand(
          `Erro ao buscar mesas disponíveis: ${error.message}`,
          `error`
        );
      }
    };

    fetchAvailableCounters();
  }, []);

  const [selectedCounter, setSelectedCounter] = useState<Counter | null>(null);

  const handleChangeCounterUuid = (event: ChangeEvent<HTMLSelectElement>) => {
    const selectedCounter = availableCounters.find(
      (counter: Counter) => counter.itemName === event.target.value
    );
    setSelectedCounter(selectedCounter || null);
    setSearchValueInput(event.target.value);
  };
  //FIM DO COUNTER SELECIONADO

  //ALTERAR TAXAS SELECIONADAS:
  interface TaxType {
    taxUuid: string;
    taxName: string;
    taxType: string;
    taxValue: string;
  }
  // Adicione este estado para armazenar as taxas selecionadas
  const [selectedTaxs, setSelectedTaxs] = useState<string[]>(); // Add the type argument for the useState hook

  // Adicione esta função para lidar com as mudanças nos checkboxes
  const taxHandleCheckboxChange = (taxUuid: string) => {

    if (selectedTaxs?.includes(taxUuid)) {
      setSelectedTaxs(selectedTaxs?.filter((tax) => tax !== taxUuid));
    } else {
      setSelectedTaxs((prevState) => [...(prevState || []), taxUuid]);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      if (orderDataZustand?.orderInfo?.orderTaxs?.length > 0) {
        setSelectedTaxs(
          orderDataZustand?.orderInfo?.orderTaxs.map(
            (tax: TaxType) => tax.taxUuid
          )
        );
      }
    }, 50);
  }, [setOrderDataZustand, orderDataZustand]);

  //FIM DO TAXAS SELECIONADAS

  //ALTERAR NÚMERO DE PESSOAS:

  const [peopleNumber, setPeopleNumber] = useState(
    orderDataZustand?.orderInfo?.peopleNumber
  );

  useEffect(() => {
    if (orderDataZustand?.orderInfo?.peopleNumber) {
      setPeopleNumber(orderDataZustand?.orderInfo?.peopleNumber);
    }
  }
    , [setOrderDataZustand, orderDataZustand]);
  //FIM DO NÚMERO DE PESSOAS


  //ALTERAR FORMA DE PAGAMENTO:
  type PaymentEnteredValue = {
    paymentMethod: {
      paymentMethodUuid: string;
      paymentMethodType: string;
      paymentMethodName: string;
    };
    value: number;
  };
  type PaymentInputValue = {
    paymentMethod: {
      paymentMethodUuid: string;
      paymentMethodType: string;
      paymentMethodName: string;
    };
    value: number;
  };
  const [paymentEnteredValues, setPaymentEnteredValues] = useState<PaymentEnteredValue[]>([]);
  const [paymentInputValues, setPaymentInputValues] = useState<PaymentInputValue[]>([]);

  const paymentHandleEnter = (
    event: React.KeyboardEvent<HTMLInputElement>,
    paymentMethod: {
      paymentMethodUuid: string;
      paymentMethodType: string;
      paymentMethodName: string;
    }
  ) => {
    if (event.key === "Enter") {
      const inputValue = Number(event.currentTarget.value);
      if (inputValue === 0) {
        const value =
          (Number(orderDataZustand.totals?.total?.replace(",", ".")) -
            paymentEnteredValues.reduce(
              (sum, entry) =>
                sum +
                (Number(entry.value) ?? 0),
              0
            )).toFixed(2);
        setPaymentInputValues((prevValues: any) => [
          ...prevValues.filter(
            (iv: any) =>
              iv.paymentMethod.paymentMethodUuid !==
              paymentMethod.paymentMethodUuid
          ),
          { paymentMethod, value: value }, // Convert value to number
        ]);
      } else {
        setPaymentEnteredValues((prevValues) => [
          ...prevValues,
          { paymentMethod, value: inputValue },
        ]);
        setPaymentInputValues((prevValues) => [
          ...prevValues.filter(
            (iv) =>
              iv.paymentMethod.paymentMethodUuid !==
              paymentMethod.paymentMethodUuid
          ),
          { paymentMethod, value: 0 },
        ]);
        // Format the value for display
        event.currentTarget.value = inputValue.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
        });
      }
    }
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const orderPayments = orderDataZustand.orderInfo?.orderPayments;
        const paymentMethods = subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodPayments?.PaymentMethods;
        if (orderPayments) {
          const enteredOrderValues = orderPayments.map((payment: any) => {
            return {
              paymentMethod: paymentMethods.find(
                (method: any) =>
                  method.paymentMethodUuid === payment.paymentMethodUuid
              ) ?? {
                paymentMethodUuid: "",
                paymentMethodType: "",
                paymentMethodName: "",
              },
              value: Number(payment.paymentValue),
            };
          }
          );
          setPaymentEnteredValues((prevValues) => [
            ...prevValues,
            ...enteredOrderValues,
          ]);
        }
      }, 50);
    }
  }, [setOrderDataZustand, orderDataZustand, isOpen]);
  const sortPaymentMethods = (methods: any) => {
    return methods?.sort((a: { paymentMethodType: string; }, b: { paymentMethodType: string; }) => {
      const order = ['cash', 'card', 'others'];
      return order.indexOf(a.paymentMethodType) - order.indexOf(b.paymentMethodType);
    });
  };
  // Modifique esta função para enviar todas as taxas selecionadas para a API
  const handleSubmit = async () => {
    const paymentEnteredValuesString = JSON.stringify(paymentEnteredValues);
    const orderPaymentsString = JSON.stringify(orderDataZustand?.orderInfo?.orderPayments || []);
    const orderTaxs = orderDataZustand?.orderInfo?.orderTaxs?.map((tax: TaxType) => tax.taxUuid) || [];

    if (paymentEnteredValuesString !== orderPaymentsString) {
      try {
        api.post(`addOrderPayment/${orderDataZustand.orderUuid}`, {
          payments: paymentEnteredValues.map((entry) => {
            return {
              paymentMethodUuid: entry.paymentMethod.paymentMethodUuid,
              value: entry.value,
            };
          }),
        });
      } catch (error: any) {
        // ... o resto do código ...
      }
    }
    if (JSON.stringify(selectedTaxs) !== JSON.stringify(orderTaxs)) {
      try {
        api.post(`updateOrderTaxs/${orderDataZustand.orderUuid}`, {
          selectedTaxs: selectedTaxs?.filter((tax: string) => tax !== undefined),
          period: subsidiaryDataZustand.selectedPdv.selectedPeriod.periodType,
        });
      } catch (error: any) {
        // ... o resto do código ...
      }
    }
    if (peopleNumber !== orderDataZustand?.orderInfo?.peopleNumber) {
      try {
        api.post(`updatePeopleNumber/${orderDataZustand.orderUuid}`, {
          peopleNumber,
        });
      } catch (error: any) {
        // ... o resto do código ...
      }
    }
    if (
      selectedDesk &&
      selectedDesk.itemUuid !== orderDataZustand?.orderInfo?.deskUuid
    ) {
      try {
        api.post(`updateItemUuid/${orderDataZustand.orderUuid}`, {
          itemUuid: selectedDesk?.itemUuid,
        });
      } catch (error: any) {
        // ... o resto do código ...
      }
    }
    if (
      selectedCounter &&
      selectedCounter.itemUuid !== orderDataZustand?.orderInfo?.counterUuid
    ) {
      try {
        api.post(`updateItemUuid/${orderDataZustand.orderUuid}`, {
          itemUuid: selectedCounter?.itemUuid,
        });
      } catch (error: any) {
        // ... o resto do código ...
      }
    }
    setPaymentEnteredValues([]);
    setMessageZustand(`Informações atualizadas com sucesso!`, `success`);
    onRequestClose();
  };

  useEffect(() => {
    if (isOpen) {
      modalWrapperRef.current?.focus();
    }
  }, [setOrderDataZustand, orderDataZustand]);

  const handleKeyDown = async (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      //await handleSubmit();
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setPaymentEnteredValues([]);
        onRequestClose();
      }}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <MessageBox />
      <Styles.ModalWrapper
        tabIndex={-1}
        ref={modalWrapperRef}
        onKeyDown={handleKeyDown}
      >
        <Styles.CloseButton
          onClick={() => {
            setPaymentEnteredValues([]);
            onRequestClose();
          }}
        >
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>Revisar Informações</Styles.ModalTitle>
            <Styles.ModalDescription>
              Atualize as informações da conta.
            </Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .backgroundColor
            }
          >
            {Object.keys(orderDataZustand.orderInfo)?.map((key: string, index: number) => {
              if (key === "deskUuid") {
                return (
                  <Styles.RowContainer>
                    <Styles.FieldLabel>
                      Alterar Número da Mesa
                    </Styles.FieldLabel>
                    <Styles.ItemUuidDropdownInput
                      color={
                        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                          .buttonsColor
                      }
                    >
                      <select onChange={handleChangeDeskUuid} value={orderDataZustand.orderInfo[key]}>
                        <option value="">Selecione</option>
                        {availableDesks
                          .sort((a, b) => {
                            const numA = parseInt(a.itemName.replace(/\D/g, ""));
                            const numB = parseInt(b.itemName.replace(/\D/g, ""));
                            return numA - numB;
                          })
                          ?.map((desk: any, index: number) => (
                            <option key={index} value={desk.itemName}>
                              {desk.itemName}
                            </option>
                          ))}
                      </select>
                      <label>Mesas Disponíveis</label>
                    </Styles.ItemUuidDropdownInput>
                  </Styles.RowContainer>
                );
              } else if (key === "peopleNumber") {
                return (
                  <Styles.RowContainer key={index}>
                    <Styles.FieldLabel>
                      Alterar Número de Pessoas
                    </Styles.FieldLabel>
                    <Styles.FieldContainer>
                      <Styles.NumberInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                            .buttonsColor
                        }
                      >
                        <input
                          type="number"
                          placeholder=""
                          value={peopleNumber}
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            setPeopleNumber(e.target.value)
                          }
                        />
                      </Styles.NumberInput>
                      <Styles.Unit
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                            .buttonsColor
                        }
                      >
                        Pessoas
                      </Styles.Unit>
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                );
              } else if (key === "counterUuid") {
                return (
                  <Styles.RowContainer key={index}>
                    <Styles.FieldLabel>
                      Alterar Número do Balcão
                    </Styles.FieldLabel>
                    <Styles.ItemUuidDropdownInput
                      color={
                        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                          .buttonsColor
                      }
                    >
                      <select onChange={handleChangeCounterUuid}>
                        <option value="">Selecione</option>
                        {availableCounters
                          .sort((a, b) => {
                            const numA = parseInt(a.itemName.replace(/\D/g, ""));
                            const numB = parseInt(b.itemName.replace(/\D/g, ""));
                            return numA - numB;
                          })
                          .map((counter: any, index: number) => (
                            <option key={index} value={counter.itemName}>
                              {counter.itemName}
                            </option>
                          ))}
                      </select>
                      <label>Balcões Disponíveis</label>
                    </Styles.ItemUuidDropdownInput>
                  </Styles.RowContainer>
                );
              } else if (key === "orderPayments") {
                return (
                  <>
                    <Styles.RowContainer>
                      <Styles.FieldLabel>
                        Alterar Pagamentos
                      </Styles.FieldLabel>
                    </Styles.RowContainer>
                    <Styles.RowContainer>

                      <Styles.PaymentTableContainer key={index}>
                        <Styles.PaymentTableWrapper>
                          <Styles.PaymentTable>
                            <Styles.PaymentTableHeader>Formas de Pagamento</Styles.PaymentTableHeader>
                            <Styles.PaymentTableHeader>Digite o valor</Styles.PaymentTableHeader>
                            <Styles.PaymentTableBody>
                              {sortPaymentMethods(
                                subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo
                                  ?.periodPayments?.PaymentMethods
                              )?.map((method: any, index: number) => {
                                // Adicionar header entre os tipos de pagamento
                                const showHeader =
                                  index === 0 ||
                                  method.paymentMethodType !==
                                  sortPaymentMethods(
                                    subsidiaryDataZustand.selectedPdv.selectedPeriod
                                      .periodInfo?.periodPayments?.PaymentMethods
                                  )[index - 1].paymentMethodType;
                                return (
                                  <React.Fragment key={index}>
                                    {showHeader && (
                                      <tr>
                                        <Styles.PaymentTableHeader colSpan={2}>
                                          {method.paymentMethodType === "cash"
                                            ? "Dinheiro"
                                            : method.paymentMethodType === "card"
                                              ? "Cartão"
                                              : "Outros Métodos de Pagamento"}
                                        </Styles.PaymentTableHeader>
                                      </tr>
                                    )}
                                    <Styles.PaymentTableRow>
                                      <Styles.PaymentTableCell>
                                        {method.paymentMethodName}
                                      </Styles.PaymentTableCell>
                                      <Styles.PaymentTableCell>
                                        <input
                                          type="number"
                                          name={method.paymentMethodName}
                                          value={
                                            paymentInputValues.find(
                                              (iv) =>
                                                iv.paymentMethod.paymentMethodUuid ===
                                                method.paymentMethodUuid
                                            )?.value || ""
                                          }
                                          onKeyPress={(event) =>
                                            paymentHandleEnter(event, method)
                                          }
                                          onChange={(event) => {
                                            setPaymentInputValues((prevValues) => [
                                              ...prevValues.filter(
                                                (iv) =>
                                                  iv.paymentMethod.paymentMethodUuid !==
                                                  method.paymentMethodUuid
                                              ),
                                              {
                                                paymentMethod: method,
                                                value: Number(event.target.value),
                                              },
                                            ]);
                                          }}
                                        />
                                      </Styles.PaymentTableCell>
                                    </Styles.PaymentTableRow>
                                  </React.Fragment>
                                );
                              })}
                            </Styles.PaymentTableBody>
                          </Styles.PaymentTable>
                        </Styles.PaymentTableWrapper>
                        <Styles.PaymentDivider />
                        <Styles.PaymentTableWrapper>
                          <Styles.PaymentTable>
                            <Styles.PaymentTableHeader>Forma de Pagamento</Styles.PaymentTableHeader>
                            <Styles.PaymentTableHeader>Registrados</Styles.PaymentTableHeader>
                            <Styles.PaymentTableBody>
                              {paymentEnteredValues.map((entry, index) => (
                                <Styles.PaymentTableRow key={index}>
                                  <Styles.PaymentTableCell>
                                    {entry.paymentMethod?.paymentMethodName === ""
                                      ? "Conta Corrente"
                                      : entry.paymentMethod?.paymentMethodName}
                                  </Styles.PaymentTableCell>
                                  <Styles.PaymentTableCell>
                                    {entry.value.toFixed(2).replace(".", ",")}
                                    <Styles.PaymentTableRowRemoveButton
                                      onClick={() =>
                                        setPaymentEnteredValues(
                                          paymentEnteredValues.filter((_, i) => i !== index)
                                        )
                                      }
                                    >
                                      &times;
                                    </Styles.PaymentTableRowRemoveButton>
                                  </Styles.PaymentTableCell>
                                </Styles.PaymentTableRow>
                              ))}
                            </Styles.PaymentTableBody>
                            <Styles.PaymentTableFooter>
                              <Styles.PaymentTableFooterRow>
                                <Styles.PaymentTableFooterCell>Total da Conta</Styles.PaymentTableFooterCell>
                                <Styles.PaymentTableFooterCell>
                                  {orderDataZustand.totals?.total}
                                </Styles.PaymentTableFooterCell>
                              </Styles.PaymentTableFooterRow>
                              <Styles.PaymentTableFooterRow>
                                <Styles.PaymentTableFooterCell>
                                  Pagamentos Registrados
                                </Styles.PaymentTableFooterCell>
                                <Styles.PaymentTableFooterCell>
                                  {paymentEnteredValues
                                    .reduce(
                                      (sum, entry) => sum + Number(entry.value),
                                      0
                                    )
                                    .toFixed(2)
                                    .replace(".", ",")}
                                </Styles.PaymentTableFooterCell>
                              </Styles.PaymentTableFooterRow>
                              <Styles.PaymentTableFooterRow>
                                <Styles.PaymentTableFooterCell>Troco</Styles.PaymentTableFooterCell>
                                <Styles.PaymentTableFooterCell>
                                  {(
                                    paymentEnteredValues.reduce(
                                      (sum, entry) => sum + Number(entry.value),
                                      0
                                    ) -
                                    (Number(
                                      orderDataZustand.totals?.total?.replace(",", ".")
                                    ) || 0)
                                  ).toFixed(2)}
                                </Styles.PaymentTableFooterCell>
                              </Styles.PaymentTableFooterRow>
                            </Styles.PaymentTableFooter>
                          </Styles.PaymentTable>
                        </Styles.PaymentTableWrapper>
                      </Styles.PaymentTableContainer>
                    </Styles.RowContainer>
                  </>
                );
              }
            })}
            <Styles.RowContainer>
              <Styles.FieldLabel>
                Alterar Taxas
              </Styles.FieldLabel>
            </Styles.RowContainer>
            <Styles.RowContainer>
              <Styles.TaxTableContainer>
                <Styles.TaxProductsTable>
                  <thead>
                    <tr>
                      <th style={{ width: "40%" }}>Nome da Taxa</th>
                      <th style={{ width: "25%" }}>Tipo de Taxa</th>
                      <th style={{ width: "25%" }}>Valor da Taxa</th>
                      <th style={{ width: "25%" }}>Aplicada?</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodTaxs?.Taxs?.map(
                      (tax: any, index: number) => (
                        <Styles.TaxTableRow
                          key={tax.taxUuid}
                          onClick={() => taxHandleCheckboxChange(tax.taxUuid)}
                        >
                          <td>{tax.taxName}</td>
                          <td>
                            {tax.taxValue.includes("%")
                              ? "Porcentagem"
                              : "Fixa"}
                          </td>
                          <td>{tax.taxValue}</td>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedTaxs?.includes(
                                tax.taxUuid as any
                              )}
                            />
                          </td>
                        </Styles.TaxTableRow>
                      )
                    )}
                  </tbody>
                </Styles.TaxProductsTable>
              </Styles.TaxTableContainer>
            </Styles.RowContainer>
          </Styles.ModalBody>
          <Styles.ModalFooter
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Button
              onClick={() => {
                setPaymentEnteredValues([]);
                onRequestClose();
              }}
            >
              Cancelar
            </Styles.Button>
            <Styles.Button onClick={handleSubmit}>Atualizar</Styles.Button>
          </Styles.ModalFooter>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal >
  );
};

export default ReviewOrderInfoModal;
